function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import { showLayerSelectionPopup } from './LayerSelectionPopup';
import { MapModuleButton } from '../../MapModuleButton';
import ReactDOM from 'react-dom';
import { LayersIcon } from 'oskari-ui/components/icons';

/**
 * @class Oskari.mapframework.bundle.mapmodule.plugin.LayerSelectionPlugin
 *
 * This is a plugin to bring more functionality for the mapmodules map
 * implementation. It provides a maplayer selection "dropdown" on top of the map.
 *
 * See http://www.oskari.org/trac/wiki/DocumentationBundleMapModulePluginLayerSelectionPlugin
 */
Oskari.clazz.define('Oskari.mapframework.bundle.mapmodule.plugin.LayerSelectionPlugin',
/**
 * @method create called automatically on construction
 * @static
 */
function (config) {
  var me = this;
  me._clazz = 'Oskari.mapframework.bundle.mapmodule.plugin.LayerSelectionPlugin';
  me._defaultLocation = 'top left';
  me._index = 70;
  me._name = 'LayerSelectionPlugin';
  me.initialSetup = true;
  me.templates = {};
  me._styleSelectable = !!this.getConfig().isStyleSelectable;
  me._showMetadata = !!this.getConfig().showMetadata;
  me._layers = [];
  me._baseLayers = [];
}, {
  _toggleToolState: function _toggleToolState() {
    if (this.popupControls) {
      this.popupCleanup();
    } else {
      this.showPopup();
    }
  },
  showPopup: function showPopup() {
    var _this = this;
    // TODO: set default baselayer!!
    this.popupControls = showLayerSelectionPopup(this._baseLayers, this._layers, function () {
      return _this.popupCleanup();
    }, this.getShowMetadata(), this.getStyleSelectable(), function (layer, visible, isBaseLayer) {
      if (isBaseLayer) {
        _this.selectBaseLayer(layer.getId());
      } else {
        _this._setLayerVisible(layer, visible);
      }
    }, function (layerId, style) {
      return _this._selectStyle(layerId, style);
    }, this.getLocation());
    this.refresh();
  },
  _updateLayerSelectionPopup: function _updateLayerSelectionPopup() {
    if (!this.popupControls) {
      return;
    }
    this.popupControls.update(this._baseLayers, this._layers, this.getShowMetadata(), this.getStyleSelectable());
  },
  popupCleanup: function popupCleanup() {
    if (this.popupControls) {
      this.popupControls.close();
    }
    this.popupControls = null;
    var div = this.getElement();
    if (!div) return;
    this.refresh();
  },
  /**
   * @private @method _initImpl
   * Interface method for the module protocol. Initializes the request
   * handlers/templates.
   */
  _initImpl: function _initImpl() {
    var me = this;
    me._loc = Oskari.getLocalization('MapModule', Oskari.getLang() || Oskari.getDefaultLanguage(), true).plugin.LayerSelectionPlugin;
    me.templates.main = jQuery('<div class="mapplugin layerselection"></div>');
    this.updateLayers();
  },
  /**
   * @method _createEventHandlers
   * Create eventhandlers.
   *
   *
   * @return {Object.<string, Function>} EventHandlers
   */
  _createEventHandlers: function _createEventHandlers() {
    return {
      /**
       * @method AfterMapLayerRemoveEvent
       * @param {Oskari.mapframework.event.common.AfterMapLayerRemoveEvent} event
       *
       * Removes the layer from selection
       */
      AfterMapLayerRemoveEvent: function AfterMapLayerRemoveEvent() {
        this.updateLayers();
      },
      /**
       * @method AfterMapLayerAddEvent
       * @param {Oskari.mapframework.event.common.AfterMapLayerAddEvent} event
       *
       * Adds the layer to selection
       */
      AfterMapLayerAddEvent: function AfterMapLayerAddEvent(event) {
        this.updateLayers();
      },
      /**
       * @method MapModulePlugin_MapLayerVisibilityRequest
       * refreshes checkbox state based on visibility
       */
      MapLayerVisibilityChangedEvent: function MapLayerVisibilityChangedEvent() {
        this.updateLayers();
      },
      AfterChangeMapLayerStyleEvent: function AfterChangeMapLayerStyleEvent() {
        this.updateLayers();
      },
      /**
       * @method AfterRearrangeSelectedMapLayerEvent
       * @param {Oskari.mapframework.event.common.AfterRearrangeSelectedMapLayerEvent} event
       *
       * Rearranges layers
       */
      AfterRearrangeSelectedMapLayerEvent: function AfterRearrangeSelectedMapLayerEvent(event) {
        // Layer order has been changed by someone, re-sort layers
        if (event._creator !== this.getName()) {
          this.updateLayers();
        }
      },
      MapSizeChangedEvent: function MapSizeChangedEvent(evt) {
        this._handleMapSizeChanged({
          width: evt.getWidth(),
          height: evt.getHeight()
        });
      }
    };
  },
  _handleMapSizeChanged: function _handleMapSizeChanged(size, isMobile) {
    var me = this,
      mobile = isMobile || Oskari.util.isMobile();
    if (!mobile && me.layerContent) {
      me.layerContent.find('div.layers-content').css('max-height', 0.75 * size.height + 'px');
    }
  },
  resetUI: function resetUI() {
    this.popupCleanup();
  },
  /**
   * @method preselectLayers
   * Does nothing, protocol method for mapmodule-plugin
   */
  preselectLayers: function preselectLayers() {},
  /**
   * @method setStyleSelectable
   * Set if layer styles should be selectable by user
   * @param {Boolean} isSelectable
   */
  setStyleSelectable: function setStyleSelectable(isSelectable) {
    this.setConfig(_objectSpread(_objectSpread({}, this.getConfig()), {}, {
      isStyleSelectable: !!isSelectable
    }));
    this._updateLayerSelectionPopup();
  },
  /**
   * @method setShowMetadata
   * @param {Boolean} showMetadata
   */
  setShowMetadata: function setShowMetadata(showMetadata) {
    this.setConfig(_objectSpread(_objectSpread({}, this.getConfig()), {}, {
      showMetadata: !!showMetadata
    }));
    this._updateLayerSelectionPopup();
  },
  /**
   * @method getStyleSelectable
   * @return {Boolean} can layer styles be selectable by user
   */
  getStyleSelectable: function getStyleSelectable() {
    return !!this.getConfig().isStyleSelectable;
  },
  getShowMetadata: function getShowMetadata() {
    return !!this.getConfig().showMetadata;
  },
  updateLayers: function updateLayers() {
    var _ref = this.getConfig() || {},
      _ref$baseLayers = _ref.baseLayers,
      baseLayers = _ref$baseLayers === void 0 ? [] : _ref$baseLayers;
    var isBaseLayer = function isBaseLayer(layer) {
      return baseLayers.some(function (id) {
        return '' + id === '' + layer.getId();
      });
    };
    // bottom layer is first in list. Reverse lists to render in correct order.
    this._layers = this.getSandbox().findAllSelectedMapLayers().filter(function (l) {
      return !isBaseLayer(l);
    }).reverse();
    this._baseLayers = this.getSandbox().findAllSelectedMapLayers().filter(isBaseLayer).reverse();
    this._updateLayerSelectionPopup();
  },
  _selectStyle: function _selectStyle(layerId, style) {
    this.getSandbox().postRequestByName('ChangeMapLayerStyleRequest', [layerId, style]);
  },
  /**
   * @method _setLayerVisible
   * Makes given layer visible or hides it
   * @param {Oskari.mapframework.domain.WmsLayer/Oskari.mapframework.domain.WfsLayer/Oskari.mapframework.domain.VectorLayer} layer layer to control
   * @param {Boolean} blnVisible true to show, false to hide
   * @private
   */
  _setLayerVisible: function _setLayerVisible(layer, blnVisible) {
    var layerId = layer.getId();
    this.getSandbox().postRequestByName('MapModulePlugin.MapLayerVisibilityRequest', [layerId, blnVisible]);
  },
  /**
   * @method addBaseLayer
   * Assumes that the layer is already added as normal layer and moves it to being a base layer
   * @param {Oskari.mapframework.domain.WmsLayer/Oskari.mapframework.domain.WfsLayer/Oskari.mapframework.domain.VectorLayer} layer layer to move
   */
  addBaseLayer: function addBaseLayer(layer) {
    if (!layer || !layer.getId) {
      return;
    }
    var alreadyAdded = this._baseLayers.some(function (l) {
      return '' + l.getId() === '' + layer.getId();
    });
    if (alreadyAdded) {
      return;
    }
    this._baseLayers.push(layer);
    this.setConfig(_objectSpread(_objectSpread({}, this.getConfig()), {}, {
      baseLayers: this._baseLayers.map(function (l) {
        return l.getId();
      })
    }));
    this._changedBaseLayer();
    this.updateLayers();
  },
  /**
   * @method removeBaseLayer
   * Assumes that the layer is already added as base layer and moves it to being a normal layer
   * @param {Oskari.mapframework.domain.WmsLayer/Oskari.mapframework.domain.WfsLayer/Oskari.mapframework.domain.VectorLayer} layer layer to move
   */
  removeBaseLayer: function removeBaseLayer(layer) {
    var old = this.getConfig();
    var newConfig = _objectSpread(_objectSpread({}, old), {}, {
      baseLayers: old.baseLayers.filter(function (id) {
        return '' + id !== '' + layer.getId();
      })
    });
    if (layer.getId() + '' === old.defaultBaseLayer + '') {
      // removed the currently selected base layer
      newConfig.defaultBaseLayer = newConfig.baseLayers[0];
    }
    this.setConfig(newConfig);
    this._changedBaseLayer();
    this.updateLayers();
    // make layer visible by default when toggled out of base layers
    this._setLayerVisible(layer, true);
  },
  /**
   * @method selectBaseLayer
   * Tries to find given layer from baselayers and select it programmatically
   * @param {String} layerId id for layer to select
   */
  selectBaseLayer: function selectBaseLayer(layerId) {
    var old = this.getConfig();
    this.setConfig(_objectSpread(_objectSpread({}, old), {}, {
      defaultBaseLayer: layerId || old.baseLayers[0]
    }));
    this._changedBaseLayer();
  },
  /**
   * @method getBaseLayers
   * Returns list of the current base layers and which one is selected
   * @return {Object} returning object has property baseLayers as a {String[]} list of base layer ids and
   * {String} defaultBase as the selected base layers id
   */
  getBaseLayers: function getBaseLayers() {
    var config = this.getConfig();
    return {
      baseLayers: config.baseLayers,
      defaultBaseLayer: config.defaultBaseLayer || config.baseLayers[0]
    };
  },
  /**
   * @method _changedBaseLayer
   * Checks which layer is currently the selected base layer, shows it and hides the rest
   * @private
   */
  _changedBaseLayer: function _changedBaseLayer() {
    var _this2 = this;
    var sandbox = this.getSandbox();
    var values = this.getBaseLayers();
    var selectedBaseLayerId = values.defaultBaseLayer;
    values.baseLayers.forEach(function (layerId) {
      var layer = sandbox.findMapLayerFromSelectedMapLayers(layerId);
      if (!layer) {
        return;
      }
      var isSelectedBaseLayer = '' + selectedBaseLayerId === '' + layerId;
      _this2._setLayerVisible(layer, isSelectedBaseLayer);
    });
    // send Request to rearrange layers
    sandbox.postRequestByName('RearrangeSelectedMapLayerRequest', [selectedBaseLayerId, 0]);
  },
  _togglePopup: function _togglePopup() {
    if (this.popupControls) {
      this.popupCleanup();
    } else {
      this.showPopup();
    }
  },
  /**
   * @private @method  _createControlElement
   * Creates the whole ui from scratch and writes the plugin in to the UI.
   * Tries to find the plugins placeholder with 'div.mapplugins.left' selector.
   * If it exists, checks if there are other bundles and writes itself as the first one.
   * If the placeholder doesn't exist the plugin is written to the mapmodules div element.
   */
  _createControlElement: function _createControlElement() {
    var el = this.templates.main.clone();
    return el;
  },
  teardownUI: function teardownUI() {
    // remove old element
    this.removeFromPluginContainer(this.getElement());
    this.popupCleanup();
  },
  /**
   * Handle plugin UI and change it when desktop / mobile mode
   * @method  @public createPluginUI
   * @param  {Boolean} mapInMobileMode is map in mobile mode
   * @param {Boolean} forced application has started and ui should be rendered with assets that are available
   */
  redrawUI: function redrawUI(mapInMobileMode, forced) {
    if (!this.isVisible() || !this.isEnabled()) {
      // no point in drawing the ui if we are not visible
      return;
    }
    this.teardownUI();
    this._element = this._createControlElement();
    this.refresh();
    this.addToPluginContainer(this._element);
  },
  refresh: function refresh() {
    var _this3 = this;
    var el = this.getElement();
    if (!el) {
      return;
    }
    ReactDOM.render(/*#__PURE__*/React.createElement(MapModuleButton, {
      className: "t_layerselect",
      icon: /*#__PURE__*/React.createElement(LayersIcon, null),
      title: this._loc.title,
      onClick: function onClick(e) {
        return _this3._togglePopup();
      },
      iconActive: this.popupControls ? true : false,
      position: this.getLocation()
    }), el[0]);
  },
  /**
   * @method _stopPluginImpl BasicMapModulePlugin method override
   * @param {Oskari.Sandbox} sandbox
   */
  _stopPluginImpl: function _stopPluginImpl(sandbox) {
    this.teardownUI();
    this._layers = [];
    this._baseLayers = [];
  }
}, {
  'extend': ['Oskari.mapping.mapmodule.plugin.BasicMapModulePlugin'],
  /**
   * @static @property {string[]} protocol array of superclasses
   */
  'protocol': ['Oskari.mapframework.module.Module', 'Oskari.mapframework.ui.module.common.mapmodule.Plugin']
});